import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { BaseDto } from '@models/base/baseDto.model';
import { ExpedienteSummaryDto } from '@models/expediente/expedienteSummary.model';
import { LoginService } from '@services/login/login.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ButtonAddComponent } from 'src/app/component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from 'src/app/component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { ButtonCloseComponent } from 'src/app/component/button-close/button-close.component';
import { ButtonDeleteAndCancelComponent } from 'src/app/component/button-delete-and-cancel/button-delete-and-cancel.component';
import { ButtonDeleteComponent } from 'src/app/component/button-delete/button-delete.component';
import { ButtonSaveComponent } from 'src/app/component/button-save/button-save.component';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { EmpresaUsuarioService } from '@services/empresaUsuario/empresaUsuario.service';
import { EmpresaUsuarioDto } from '@models/empresaUsuario/empresaUsuarioDto.model';
import { isFalsy } from 'utility-types';
import { EstadoTareaService } from '@services/estadoTarea/estadoTarea.service';
import { CuentaContableService } from '@services/cuentaContable/cuentaContable.service';
import { CuentaCajaService } from '@services/cuentaCaja/cuentaCaja.service';
import { DtoBase } from '@models/base/dtoBase.model';
import { CuentaCajaDto } from '@models/cuentaCaja/cuentaCajaDto.model';
import { CuentaContableDto } from '@models/cuentaContable/cuentaContableDto.model';
import { TipoMonedaService } from '@services/tipoMoneda/tipoMoneda.service';
import { MatChipEditedEvent, MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MonedaDirective } from '@directives/moneda.directive';
import { SelectUsuariosEmpresaComponent } from 'src/app/component/select-usuarios-empresa/select-usuarios-empresa.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { TareaDto } from '@models/tarea/tareaDto.model';
import { TareaService } from '@services/tarea/tarea.service';
import { CreateTareaRequest } from '@models/tarea/createTareaRequest.model';
import { UpdateTareaRequest } from '@models/tarea/updateTareaRequest.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { TiposTareaService } from '@services/tipoTarea/tipoTarea.service';

@Component({
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDatepickerModule, MatRadioModule, MatSelectModule, FormsModule, MatSortModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, BuscarExpedienteComponent, MatTabsModule, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule, ButtonDeleteComponent, MatAutocompleteModule, MatChipsModule, MatTabsModule, MonedaDirective, SelectUsuariosEmpresaComponent, NgxMaskDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [provideNgxMask()],
  templateUrl: `dialog-form-tarea.component.html`,
  styleUrl: './dialog-form-tarea.component.css',
})


export class DialogFormTareaComponent {

  lstNiveles: BaseDto[] = [
    { id: 1, descripcion: 'Baja' },
    { id: 2, descripcion: 'Media' },
    { id: 3, descripcion: 'Alta' },
  ];

  lstPrioridades: BaseDto[] = [
    { id: 1, descripcion: 'Baja' },
    { id: 2, descripcion: 'Media' },
    { id: 3, descripcion: 'Alta' },
  ];
  estadostarea!: BaseDto[];
  expedienteDto!: ExpedienteSummaryDto;
  paises!: BaseDto[];
  empresaUsuarioDto!: EmpresaUsuarioDto;
  tarea: any;
  tiposTarea!: BaseDto[];
  tareaDto!: TareaDto;
  tiposMoneda!: BaseDto[];
  get f() { return this.form.controls; }
  accionesDialog = AccionesDialog;
  form!: FormGroup;
  localData: any;
  formBuilder: FormBuilder = new FormBuilder;
  estadosTarea!: DtoBase[];
  cuentasContables!: CuentaContableDto[];
  cuentasCaja!: CuentaCajaDto[];
  etiquetas = [''];

  constructor(
    public dialogRef: MatDialogRef<DialogFormTareaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private tipoTareaService: TiposTareaService,
    private tareaService: TareaService,
    private empresaUsuarioService: EmpresaUsuarioService,
    private router: Router,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
    private estadoTareaService: EstadoTareaService,

  ) {

    this.getAllTiposTarea()
    this.getAllEstadosTarea()
  }

  ngOnInit(): void {

    this.tarea = this.data?.item || {};
    this.setForm();
  }
  onUsuarioSeleccionado(usuario: any) {
    this.form.get('AprobadoPor')?.setValue(usuario.id);
  }

  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  getAllTiposTarea() {
    this.spinner.show("spTipoTarea")
    this.tipoTareaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTipoTarea")
          this.tiposTarea = data
        },
        error => {
          this.spinner.hide("spTipoTarea")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllEstadosTarea() {
    this.spinner.show('spEstadosTarea')
    this.estadoTareaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spEstadosTarea')
          this.estadosTarea = data
        },
        error => {
          this.spinner.hide('spEstadosTarea')
          this.snackBar.showError(error, "Error");
        })
  }


  setForm(): void {
    this.form = this.formBuilder.group({
      Id: [this.tarea?.id || null],
      Descripcion: [this.tarea?.descripcion || '', Validators.compose([Validators.maxLength(200)])],
      Observaciones: [this.tarea?.observaciones || '', Validators.compose([Validators.maxLength(500)])],
      FechaVencimiento: [this.tarea?.fechaVencimiento || null, ],
      AprobadoPor: [this.tarea?.aprobadoPor?.id || null],
      IdEstadoTarea: [this.tarea?.estadoTarea?.id || null],
      IdTipoTarea: [this.tarea?.tipoTarea?.id || null],
      IdExpediente: [this.tarea?.expediente?.id || null],
      Notificado: [this.tarea?.notificado || null],
      FechaInicioReal: [this.tarea?.fechaInicioReal || null],
      FechaInicioEstimada: [this.tarea?.fechaInicioEstimada || null],
      AutorizadoPor: [this.tarea?.autorizadoPor?.id || null],
      AsignadoA: [this.tarea?.asignadoA?.id || null],
      IdTareaPadre: [this.tarea?.tareaPadre?.id || null],
      NivelAvance: [this.tarea?.nivelAvance || null],
      Titulo: [this.tarea?.titulo || null,Validators.compose([Validators.required, Validators.maxLength(200)])],
      Prioridad: [this.tarea?.prioridad || null],
    });
  }


  getAllUsuarioByIdEmpresa() {
    this.spinner.show('spPaises')
    this.empresaUsuarioService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spPaises')
          const empresaUsuarioDtoEncontrado = data.find(x => x.usuario.id === this.loginService.getIdUser());
          if (empresaUsuarioDtoEncontrado) {
            this.empresaUsuarioDto = empresaUsuarioDtoEncontrado;
            //this.form.get('IdPais')?.setValue(this.empresaUsuarioDto.empresa.pais.id);
          }

        },
        error => {
          this.spinner.hide('spPaises')
          this.snackBar.showError(error, "Error");
        })
  }

  selectExpediente($event: any) {
    this.expedienteDto = $event
    this.form.controls['IdExpediente'].setValue(this.expedienteDto.id)
  }

  cancelar() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar, data: this.data });
  }



  agregar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.spinner.show("spTarea")
    this.tareaService.create(this.setCreateTareaRequest())
      .subscribe(
        data => {
          this.spinner.hide("spTarea")
          this.snackBar.showSuccess('Registro creado con correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Agregar, data: this.data.tarea, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spTarea")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  modificar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.spinner.show("spTarea")
    this.tareaService.update(this.setUpdateTareaRequest())
      .subscribe(
        data => {
          this.spinner.hide("spTarea")
          this.snackBar.showSuccess('Registro modificado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Modificar, data: this.data.tarea, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spTarea")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  eliminar() {
    this.spinner.show("spTarea")
    this.tareaService.delete(this.tarea.id)
      .subscribe(
        data => {
          this.spinner.hide("spTarea")
          this.snackBar.showSuccess('Registro eliminado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Eliminar, data: this.data.tarea, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spTarea")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  setCreateTareaRequest(): CreateTareaRequest {
    const createTareaRequest = new CreateTareaRequest();

    createTareaRequest.descripcion = this.form.controls['Descripcion'].value;
    createTareaRequest.observaciones = this.form.controls['Observaciones'].value;
    createTareaRequest.fechaVencimiento = this.form.controls['FechaVencimiento'].value || null;
    createTareaRequest.autorizadoPor = this.form.controls['AutorizadoPor'].value || null;
    createTareaRequest.idEstadoTarea = this.form.controls['IdEstadoTarea'].value || null;
    createTareaRequest.idTipoTarea = this.form.controls['IdTipoTarea'].value || null;
    createTareaRequest.idExpediente = this.form.controls['IdExpediente'].value || this.data?.idExpediente || null;
    createTareaRequest.notificado = this.form.controls['Notificado'].value || null;
    createTareaRequest.fechaInicioReal = this.form.controls['FechaInicioReal'].value || null;
    createTareaRequest.fechaInicioEstimada = this.form.controls['FechaInicioEstimada'].value || null;
    createTareaRequest.autorizadoPor = this.form.controls['AutorizadoPor'].value || null;
    createTareaRequest.asignadoA = this.form.controls['AsignadoA'].value || this.loginService.getIdUser();
    createTareaRequest.idTareaPadre = this.form.controls['IdTareaPadre'].value || null;
    createTareaRequest.nivelAvance = this.form.controls['NivelAvance'].value || null;
    createTareaRequest.titulo = this.form.controls['Titulo'].value || null;
    createTareaRequest.prioridad = this.form.controls['Prioridad'].value || null;

    return createTareaRequest;

  }


  setUpdateTareaRequest(): UpdateTareaRequest {
    const updateTareaRequest = new UpdateTareaRequest();

    updateTareaRequest.id = this.form.controls['Id'].value;
    updateTareaRequest.descripcion = this.form.controls['Descripcion'].value;
    updateTareaRequest.observaciones = this.form.controls['Observaciones'].value;
    updateTareaRequest.fechaVencimiento = this.form.controls['FechaVencimiento'].value || null;
    updateTareaRequest.idEstadoTarea = this.form.controls['IdEstadoTarea'].value || null;
    updateTareaRequest.idTipoTarea = this.form.controls['IdTipoTarea'].value || null;
    updateTareaRequest.idExpediente = this.form.controls['IdExpediente'].value || this.data?.idExpediente || null;
    updateTareaRequest.notificado = this.form.controls['Notificado'].value || null;
    updateTareaRequest.fechaInicioReal = this.form.controls['FechaInicioReal'].value || null;
    updateTareaRequest.fechaInicioEstimada = this.form.controls['FechaInicioEstimada'].value || null;
    updateTareaRequest.autorizadoPor = this.form.controls['AutorizadoPor'].value || null;
    updateTareaRequest.asignadoA = this.form.controls['AsignadoA'].value || this.loginService.getIdUser();
    updateTareaRequest.idTareaPadre = this.form.controls['IdTareaPadre'].value || null;
    updateTareaRequest.nivelAvance = this.form.controls['NivelAvance'].value || null;
    updateTareaRequest.titulo = this.form.controls['Titulo'].value || null;
    updateTareaRequest.prioridad = this.form.controls['Prioridad'].value || null;

    return updateTareaRequest;
  }


  onReset() {
    this.form.reset();
  }

  trackBytareas(index: number, tarea: any): any { return tarea; }



  async getTareaById(id: number) {
    this.spinner.show("spView")
    await this.tareaService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide("spView")
          this.tareaDto = data
          this.setForm();
        },
        error => {
          this.spinner.hide("spView")
          this.snackBar.showError(error, "Error");
        })
  }

  esUrlValida(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }

  abrirUrl(url: string): void {
    if (this.esUrlValida(url)) {
      window.open(url, '_blank');
    }
  }
}


